<template>
  <div>
    <b-row>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="CpuIcon"
                :statistic="totalCabinet"
                statistic-title="Total de gabinetes"
                color="info"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="WifiIcon"
                :statistic="transmitting"
                statistic-title="Gabinetes transmitiendo"
                color="success"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="WifiOffIcon"
                :statistic="NoTransmiting"
                statistic-title="Gabinetes no transmintiendo"
                color="danger"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="3" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="ClockIcon"
                :statistic="totalMeters"
                statistic-title="Total de medidores reportados"
                color="info"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="3" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="WifiIcon"
                :statistic="transmittingMeters"
                statistic-title="Medidores transmitiendo"
                color="success"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="3" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="RadioIcon"
                :statistic="transmittingMeters"
                statistic-title="Medidores transmitiendo a SiNaMed"
                color="success"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="3" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="WifiOffIcon"
                :statistic="NoTransmitingMeters"
                statistic-title="Medidores no transmintiendo"
                color="danger"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="RepeatIcon"
                :statistic="distincMeters != totalMeters ? 'Con medidores duplicados' : 'Sin medidores duplicados'"
                statistic-title="Medidores"
                :color="distincMeters != totalMeters ? 'warning' : 'success'"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="CloudIcon"
                :statistic="status_n"
                statistic-title="Gabinetes correctos"
                color="success"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col lg="4" md="12">
        <b-card class="card_statisc">
          <b-row>
            <b-col
              md="12"
              class="mb-2 mt-2"
            >
              <statistic-card-vertical
                icon="CloudOffIcon"
                :statistic="status_m"
                statistic-title="Gabinetes en mantenimiento"
                color="warning"
              />
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col md="12" >
        <b-card>
          <div class="text-center">
            <b>Gabinetes por agencias</b>
            <b-col md="12" class="text-center d-flex justify-content-end">
              <b-button
                v-if="urlDownload.length > 0 && responseData.length > 0"
                :href="urlDownload"
                download="Gabinetes_conteo.csv"
                variant="outline-primarySpore">
                Descargar CSV
              </b-button>
            </b-col>
          </div>
          <vue-apex-charts
            v-if="agenciesChart.ready"
            type="bar"
            height="400"
            :options="agenciesChart.chartOptions"
            :series="agenciesChart.series"
          />
        </b-card>
      </b-col>

      <b-col cols="12" md="3" v-for="(chart,index) in this.donutsChart" v-bind:key="index" >
        <b-card :title="chart.title">
          <vue-apex-charts
            v-if="chart.ready"
            type="donut"
            height="350"
            :options="chart.options"
            :series="chart.series"
          />
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import {
  BCard, BRow, BCol, BButton
} from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'
import { empty } from '@/libs/tools/helpers'
import request from '@/libs/request/index'
import StatisticCardVertical from '@core/components/statistics-cards/StatisticCardVertical.vue'

export default {
  components: {
    BCard,
    VueApexCharts,
    BRow,
    BCol,
    BButton,
    StatisticCardVertical
  },
  data () {
    return {
      urlDownload: '',
      responseData: [],
      totalCabinet: 0,
      transmitting: 0,
      NoTransmiting: 0,
      totalMeters: 0,
      transmittingMeters: 0,
      NoTransmitingMeters: 0,
      status_n: 0,
      status_m: 0,
      distincMeters: 0,
      agenciesChart: {
        ready: false,
        series: [
          {
            name: 'Gabinetes',
            data: []
          }
        ],
        chartOptions: {
          chart: {
            stacked: true,
            toolbar: {
              show: false
            }
          },
          plotOptions: {
            bar: {
              columnWidth: '35%',
              colors: {
                backgroundBarRadius: 5
              }
            }
          },
          dataLabels: {
            enabled: false
          },
          legend: {
            show: true,
            position: 'top',
            fontSize: '14px',
            fontFamily: 'Montserrat',
            horizontalAlign: 'left'
          },
          stroke: {
            show: true,
            colors: ['transparent']
          },
          grid: {
            xaxis: {
              lines: {
                show: true
              }
            }
          },
          xaxis: {
            categories: [],
            title: {
              text: 'Agencias'
            }
          },
          yaxis: {
            title: {
              text: 'Gabinetes'
            },
            labels: {
              formatter: function (val) {
                return val.toFixed(0)
              }
            }
          },
          fill: {
            opacity: 1
          }
        }
      },
      donutsChart: [],
      rangePicker: []
    }
  },
  methods: {
    async getDashboard () {
      const params = {
        url: 'report/general',
        method: 'GET'
      }
      await request(params).then(response => {
        if (!empty(response.data.devices)) {
          this.status_n = response.data.devices[0].status_n
          this.status_m = response.data.devices[0].status_m
        }
        if (!empty(response.data.meters)) {
          this.totalMeters = response.data.meters[0].total
          this.transmittingMeters = response.data.meters[0].transmitting
          this.NoTransmitingMeters = response.data.meters[0].no_transmitting
          this.distincMeters = response.data.meters[0].distinct_numbers
        }
        if (!empty(response.data.devicesAgencies)) {
          this.agenciesChart.series[0].data = []
          this.responseData = []
          this.agenciesChart.chartOptions.xaxis.categories = []
          this.responseData = response.data.devicesAgencies
          response.data.devicesAgencies.forEach((element, index) => {
            this.agenciesChart.series[0].data.push({
              x: element.name,
              y: parseInt(element.total),
              fillColor: '#00c3c3'
            })
          })
          this.agenciesChart.ready = true
        }

        if (!empty(response.data.cabinets)) {
          this.response = response.data.cabinets[0]
          this.totalCabinet = response.data.cabinets[0].total
          this.transmitting = response.data.cabinets[0].transmitting
          this.NoTransmiting = response.data.cabinets[0].no_transmitting
          this.donutsChart = []
          this.addChartDonut('absencePhaseA', 'Ausencia fase A')
          this.addChartDonut('absencePhaseB', 'Ausencia fase B')
          this.addChartDonut('absencePhaseC', 'Ausencia fase C')
          this.addChartDonut('communicationError', 'Error de comunicación')
          this.addChartDonut('dateTimeInvalid', 'Fecha y hora no válida')
          this.addChartDonut('fraudMeter1', 'Fraude medidor 1')
          this.addChartDonut('fraudMeter2', 'Fraude medidor 2')
          this.addChartDonut('fraudMeter3', 'Fraude medidor 3')
          this.addChartDonut('fraudMeter4', 'Fraude medidor 4')
          this.addChartDonut('fraudMeter5', 'Fraude medidor 5')
          this.addChartDonut('fraudMeter6', 'Fraude medidor 6')
          this.addChartDonut('fraudMeter7', 'Fraude medidor 7')
          this.addChartDonut('fraudMeter8', 'Fraude medidor 8')
          this.addChartDonut('fraudMeter9', 'Fraude medidor 9')
          this.addChartDonut('fraudMeter10', 'Fraude medidor 10')
          this.addChartDonut('fraudMeter11', 'Fraude medidor 11')
          this.addChartDonut('fraudMeter12', 'Fraude medidor 12')
          this.addChartDonut('hotSnapOcurred', 'Ocurrio Hot Swap')
          this.addChartDonut('loadProfileError', 'Error en perfil de carga')
          this.addChartDonut('notConsumption', 'Sin consumo')
          this.addChartDonut('notPulse24Hrs', 'Sin pulso 24 Hr')
          this.addChartDonut('openPassBox', 'Caja de paso abierta')
          this.addChartDonut('simDoorOpen', 'Puerta SIM abierta')
          this.addChartDonut('systemJustPoweredUp', 'Sistema energizado')
          this.addChartDonut('temperatureSensorActivated', 'Sensor temperatura')
        }
        this.createCsv()
      })
    },
    createCsv () {
      const csv = []
      const headers = []
      headers.push('Agencia')
      headers.push('Total Gabinetes')
      csv.push(headers.join(','))
      this.responseData.map(item => {
        const row = []
        row.push(item.name)
        row.push(item.total)
        csv.push(row.join(','))
        return item
      })
      const file = csv.join('\n')
      const csvFile = new Blob([file], { type: 'text/csv' })
      this.urlDownload = window.URL.createObjectURL(csvFile)
    },
    addChartDonut (name, title) {
      if (!empty(this.response[`${name}_true`]) && !empty(this.response[`${name}_false`])) {
        this.donutsChart[this.donutsChart.length] = this.getOptionsDonut(name)
        this.donutsChart[this.donutsChart.length - 1].series.push(parseInt(this.response[`${name}_false`]))
        this.donutsChart[this.donutsChart.length - 1].series.push(parseInt(this.response[`${name}_true`]))
        if (!empty(title)) this.donutsChart[this.donutsChart.length - 1].title = title
        this.donutsChart[this.donutsChart.length - 1].ready = true
      }
    },
    getOptionsDonut (name) {
      return {
        series: [],
        title: '',
        ready: false,
        options: {
          legend: {
            show: true,
            position: 'bottom',
            fontSize: '14px',
            fontFamily: 'Montserrat'
          },
          colors: [
            '#28C76F', '#EA5455', '#00c3c3'
          ],
          chart: {
            type: 'donut'
          },
          dataLabels: {
            enabled: true,
            formatter (val) {
              // eslint-disable-next-line radix
              return `${parseInt(val)}%`
            }
          },
          plotOptions: {
            pie: {
              donut: {
                labels: {
                  show: true,
                  name: {
                    fontSize: '2rem',
                    fontFamily: 'Montserrat'
                  },
                  value: {
                    fontSize: '1rem',
                    fontFamily: 'Montserrat',
                    formatter (val) {
                      // eslint-disable-next-line radix
                      return `${parseInt(val)}`
                    }
                  }
                }
              }
            }
          },
          labels: ['Correcto', 'En alerta'],
          responsive: [
            {
              breakpoint: 992,
              options: {
                chart: {
                  height: 380
                },
                legend: {
                  position: 'bottom'
                }
              }
            },
            {
              breakpoint: 576,
              options: {
                chart: {
                  height: 320
                },
                plotOptions: {
                  pie: {
                    donut: {
                      labels: {
                        show: true,
                        name: {
                          fontSize: '1.5rem'
                        },
                        value: {
                          fontSize: '1rem'
                        },
                        total: {
                          fontSize: '1.5rem'
                        }
                      }
                    }
                  }
                },
                legend: {
                  show: true
                }
              }
            }
          ]
        }
      }
    }
  },
  created () {
    this.getDashboard()
  }
}
</script>
<style lang="scss">
  @import '@core/scss/vue/libs/vue-flatpicker.scss';
  @import '@core/scss/vue/libs/chart-apex.scss';
</style>
